// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { KindChannel } from "../schema";

export function serialize_KindChannel_internal(value: KindChannel): unknown {
  return ((value: "channel"): unknown => {
    return value;
  })(value);
}
export function serialize_KindChannel(obj: KindChannel): string {
  return renderJsonWithNumbersAsBigint(serialize_KindChannel_internal(obj));
}
export function deserialize_KindChannel_internal(value: unknown): ParserResult<KindChannel> {
  return ((value: unknown): ParserResult<"channel"> => {
    if (typeof value !== "string") {
      return { success: false, reason: `[#/components/schemas/KindChannel]: '${value}' expected to be of type string.` };
    }
    switch (value) {
      case "channel":
        return { success: true, value: "channel" };
      default:
        return { success: false, reason: `[#/components/schemas/KindChannel]: '${value}' expected to be enum, one of 'channel'.` };
    }
  })(value);
}
export function deserialize_KindChannel(str: string): ParserResult<KindChannel> {
  return deserialize_KindChannel_internal(parseJsonWithNumbersAsBigint(str));
}
